import { ConstantItems, getDefaultConfig } from "@constants/shared";
import {
  SecurityDetails,
  NamedItem,
} from "@models/simulations/securityDetails";
import { MarketAnalsis } from "@models/cmodel/marketAnalysis";
import { Geography } from "@models/cmodel/geography";
import { Sector } from "@models/cmodel/sector";

export class CModelRepo {
  // static $inject = ["$http", "config"];
  /** @ngInject */
  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems
  ) {}

  getCModel() {
    return this.$http.get(`${this.config.cModelUrl}`);
  }

  createCModel(locality?: string, currentModelId?: any) {
    return this.$http.post(
      `${this.config.cModelUrl}?Locality=${locality}`,
      currentModelId
    );
  }

  saveModifiedCModel(modifiedCModel: any) {
    return this.$http.post(`${this.config.cModelUrl}`, modifiedCModel);
  }

  getEquityItemsList(locality: Locality) {
    let queryParams = {
      Locality: locality,
    };

    let config = getDefaultConfig();
    config.params = queryParams;
    return this.$http.get(`${this.config.cModelUrl}/EquityItems`, config);
  }

  getSecurityItemsList(
    assetClass: string,
    locality: Locality,
    findActive: Boolean
  ) {
    let queryParams = {
      assetClass: assetClass,
      Locality: locality,
      findActive: findActive,
    };

    let config = getDefaultConfig();
    config.params = queryParams;
    return this.$http
      .get<SecurityDetails[]>(`${this.config.securityManagementUrl}`, config)
      .then((resp) => resp.data);
  }

  getFixedIncomeTypes() {
    return this.$http
      .get(`${this.config.securityManagementUrl}/fixedIncomes`)
      .then((res) => res.data as NamedItem[]);
  }

  saveSecurity(security: SecurityDetails) {
    return this.$http
      .post(`${this.config.securityManagementUrl}`, security)
      .then((res) => res.data as SecurityDetails);
  }

  deleteSecurity(securityId: number) {
    return this.$http.delete(
      `${this.config.securityManagementUrl}/${securityId}`
    );
  }

  updateSecurityItems(securityItems: any) {
    return this.$http.put(
      `${this.config.securityManagementUrl}`,
      securityItems
    );
  }

  updateSecurityItem(id: number, securityItems: any) {
    return this.$http.put(
      `${this.config.securityManagementUrl}/edit`,
      securityItems
    );
  }

  getSectorsList() {
    return this.$http
      .get(`${this.config.cModelUrl}/Sectors`)
      .then((res) => res.data as Sector[]);
  }

  getGeographiesList() {
    return this.$http
      .get(`${this.config.cModelUrl}/Geographies`)
      .then((res) => res.data as Geography[]);
  }

  getAssetClassList() {
    return this.$http.get(`${this.config.cModelUrl}/AssetClasses`);
  }

  getReportSummaries() {
    return this.$http
      .get(`${this.config.cModelUrl}/reportsummaries`)
      .then((resp) => resp.data as MarketAnalsis[]);
  }

  saveReportSummaries(marketAnalysis: MarketAnalsis) {
    return this.$http
      .post(`${this.config.cModelUrl}/reportsummaries`, marketAnalysis)
      .then((resp) => resp.data as MarketAnalsis);
  }

  archiveSecurities(securityIds, archive) {
    let queryParams = {
      securityIds: securityIds,
      archive: archive,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.put(
      `${this.config.securityManagementUrl}/archive`,
      null,
      config
    );
  }
}

export enum Locality {
  Local = 0,
  International,
  Combined,
}



// WEBPACK FOOTER //
// ./src/services/cmodel.repo.ts